import { User, MapPin, Shield, Swords, ScrollText, Users, Sparkles, Tag, Languages, Leaf, PawPrint, Car, Cpu, HeartHandshake, UtensilsCrossed, Building2, Pill, Clapperboard, BookA } from "lucide-react";

export const CATEGORIES = ["Character", "Location", "Faction", "Historical_Event", "Lore", "Race", "Magic_System", "Language", "Flora", "Fauna", "Vehicle", "Technology", "Food", "Organization", "Medicine", "Popular_Culture", "Term", "Relationship"];

export const CATEGORY_META = {
  Character: { label: "Character", color: "#F59E0B", icon: User },
  Location: { label: "Location", color: "#10B981", icon: MapPin },
  Faction: { label: "Faction", color: "#3B82F6", icon: Shield },
  Historical_Event: { label: "Historical Event", color: "#8B5CF6", icon: Swords },
  Lore: { label: "Lore", color: "#EC4899", icon: ScrollText },
  Race: { label: "Race", color: "#F97316", icon: Users },
  Magic_System: { label: "Magic System", color: "#06B6D4", icon: Sparkles },
  Language: { label: "Language", color: "#14B8A6", icon: Languages },
  Flora: { label: "Flora (Plants)", color: "#65A30D", icon: Leaf },
  Fauna: { label: "Fauna (Animals)", color: "#B45309", icon: PawPrint },
  Vehicle: { label: "Vehicle", color: "#64748B", icon: Car },
  Technology: { label: "Technology", color: "#0EA5E9", icon: Cpu },
  Food: { label: "Food", color: "#EA580C", icon: UtensilsCrossed },
  Organization: { label: "Organization / Business", color: "#6366F1", icon: Building2 },
  Medicine: { label: "Medicine", color: "#F43F5E", icon: Pill },
  Popular_Culture: { label: "Popular Culture", color: "#D946EF", icon: Clapperboard },
  Term: { label: "Terms", color: "#84CC16", icon: BookA },
  Relationship: { label: "Relationship", color: "#DB2777", icon: HeartHandshake },
};

let custom = [];
export const setCustomCategories = (list) => { custom = list || []; };
export const customCategories = () => custom;
export const sortCategories = (list) => [...list].sort((a, b) => catLabel(a).localeCompare(catLabel(b), undefined, { sensitivity: "base" }));
export const allCategories = () => sortCategories(new Set([...CATEGORIES, ...custom.map((c) => c.name)]));
export const catColor = (c) => CATEGORY_META[c]?.color || custom.find((x) => x.name === c)?.color || "#A8A090";
export const catLabel = (c) => CATEGORY_META[c]?.label || c;
export const catIcon = (c) => CATEGORY_META[c]?.icon || Tag;
export const slug = (s) => String(s).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const CATEGORY_SUGGESTIONS = [
  { name: "Object", color: "#A3A3A3" }, { name: "Weapon", color: "#DC2626" }, 
  { name: "Item", color: "#CA8A04" }, { name: "Monster", color: "#9F1239" },
];
export const SWATCHES = ["#DC2626", "#EA580C", "#CA8A04", "#65A30D", "#0D9488", "#2563EB", "#7C3AED", "#DB2777", "#9F1239", "#B45309", "#64748B", "#A3A3A3"];

export const FLAG_META = {
  needs_info: { label: "Needs more info", short: "Thin", color: "#3B82F6" },
  clarify: { label: "Needs clarification", short: "Unclear", color: "#EAB308" },
  contradiction: { label: "Contradiction", short: "Conflict", color: "#EF4444" },
};
